// Scoring and colours for the Risk management tab (US 9370). The levels, the maximum and the bands come
// from the workspace's scale in the API response, so another scale (e.g. 5 × 5) needs no change here.

export const METHOD_SIMPLE = 'single_risk';
export const METHOD_CIA = 'cia_risk';
export const CIA = ['confidentiality', 'integrity', 'availability'];
export const RESPONSES = ['Accept', 'Control', 'Transfer', 'Avoid', 'Monitor'];

export function score(scale, impact, probability) {
  let i = scale.impact.indexOf(impact);
  let p = scale.probability.indexOf(probability);
  return i < 0 || p < 0 ? null : (i + 1) * (p + 1);
}

// Highest of C, I and A for a CIA rating; ratings = { confidentiality: { impact, probability }, … }
export function ciaScore(scale, ratings) {
  let scores = CIA.map(key => ratings[key] ? score(scale, ratings[key].impact, ratings[key].probability) : null).filter(value => value !== null);
  return scores.length ? Math.max.apply(null, scores) : null;
}

// low, medium, high or very_high
export function band(scale, value) {
  if (!value) {
    return null;
  }
  let keys = Object.keys(scale.bands);
  return keys.find(key => value <= scale.bands[key]) || keys[keys.length - 1];
}

// Translation key of a level name: "Very unlikely" → very_unlikely
export function levelKey(value) {
  return value ? value.toLowerCase().replace(/ /g, '_') : '';
}
